import React, {useMemo} from 'react';
import {Flex, Tag} from '@priority-software/priority-style-react';
import {AutomationChoose} from '../../../../../../../reducer/model';

type Props = {
    options: Array<AutomationChoose>;
    values: Array<string | number>;
    onChange: (values: Array<string | number>, name: string) => void;
    name: string;
};

export const MultiSelectValues = (props: Props) => {
    const {values, options, name, onChange} = props;

    const data = useMemo(() => {
        return values
            .map(value => {
                return options.find(item => item.value === value);
            })
            .filter(Boolean);
    }, [values, options]);

    return (
        <Flex justifyContent="flex-start" style={{gap: 8}} wrap>
            {data.map(item => {
                return (
                    <Tag
                        key={`${item.value}`}
                        text={item.label}
                        onClose={() =>
                            onChange(
                                values.filter(value => value !== item.value),
                                name
                            )
                        }
                    />
                );
            })}
        </Flex>
    );
};
